// knowledgeDetails.pipeline.attention.* — owned by the needs-attention page.
export default {
  nav: 'Needs attention',
  navBadge_one: '{{count}} item needs attention',
  navBadge_other: '{{count}} items need attention',
  overviewLink_one: '{{count}} needs attention →',
  overviewLink_other: '{{count}} need attention →',
  title: 'What needs attention',
  subtitle_one:
    '{{count}} item · each says where it happened, why, and the one action that fixes it',
  subtitle_other:
    '{{count}} items in {{groups}} causes · each says where it happened, why, and the one action that fixes it',
  loading: 'Looking for failures…',
  loadFailed:
    'Could not load the failed documents of this knowledge base. Reload the page to try again.',
  runsFailed:
    'Could not load the connector run history; connector failures are not shown.',
  capped:
    'Showing the {{shown}} most recently updated of {{total}} failed or cancelled documents.',
  empty: {
    title: 'Nothing needs attention',
    body: 'No failed or cancelled documents, no failed connector runs and no configuration problems in this knowledge base.',
  },
  severity: {
    blocking: {
      label: 'Blocking',
      hint: 'Ingestion or retrieval cannot proceed until someone acts.',
    },
    recoverable: {
      label: 'Recoverable',
      hint: 'Retrying from this page fixes it.',
    },
    informational: {
      label: 'Informational',
      hint: 'Nothing is broken for readers; worth knowing and cheap to fix.',
    },
    heading: '{{label}} · {{count}}',
    chip: '{{count}} {{label}}',
    summary: 'Summary by severity',
  },
  legend: {
    title: 'Card legend',
    failed: 'stage where it failed',
    cancelled: 'stage where it was cancelled',
    unaffected: 'stage not reached or unaffected',
    sample: 'text',
    error: 'the real error line',
  },
  kinds: {
    document_one: '{{count}} document',
    document_other: '{{count}} documents',
    run_one: '{{count}} connector run',
    run_other: '{{count}} connector runs',
    kb_one: 'Knowledge base setting',
    kb_other: 'Knowledge base settings',
  },
  card: {
    stagesLabel: 'Where it failed',
    number: '#{{n}}',
    configuration: 'Configuration',
    noError: 'No error line was recorded.',
    why: 'Why',
    doThis: 'Do this',
    showItems: 'Show affected ({{count}})',
    hideItems: 'Hide affected',
    more: '…and {{count}} more',
  },
  causes: {
    modelNotAuthorized: {
      label: 'Model not authorized',
      reason:
        'The model this step calls is not enabled for this workspace, so every call to it is refused.',
    },
    workflowServer: {
      label: 'Workflow server rejected the import',
      reason:
        'The workflow server that runs imports refused the request (wrong address or token). Nothing was fetched, so nothing reached Parse.',
    },
    accountAuth: {
      label: 'Source account not authorized',
      reason:
        'The connected account no longer authorizes reads (token revoked or expired, or missing permission). Syncing is blocked until it is reconnected.',
    },
    cacheExpired: {
      label: 'Staged chunks expired',
      reason:
        'Intermediate results expired before the next step ran. Resuming re-runs only the failed steps.',
    },
    rateLimited: {
      label: 'Rate limit or timeout',
      reason:
        'A provider refused or timed out under load. This is usually temporary; retrying the failed steps is enough.',
    },
    missingFile: {
      label: 'File missing or unreadable',
      reason:
        'The stored file could not be read (missing, empty, encrypted or corrupt). Parsing it again will fail the same way; upload a readable copy.',
    },
    stuckRun: {
      label: 'Run stuck or interrupted',
      reason:
        'The run stopped making progress and was interrupted. Cancel it so a new run can start, then retry what failed.',
    },
    workerCrash: {
      label: 'Parsing task crashed',
      reason:
        'A parsing task crashed inside the worker. Re-parsing runs it again on a fresh worker.',
    },
    descriptionFailed: {
      label: 'Description generation failed',
      reason:
        'The knowledge base description could not be generated. Generate it again from Configuration once the documents have chunks.',
    },
    cancelled: {
      label: 'Cancelled',
      reason:
        'Processing was cancelled before it finished, so these are not searchable yet.',
    },
    partialRun: {
      label: 'Run finished with errors',
      reason:
        'The run completed, but some items failed. Retrying picks up only the failed items.',
    },
    noErrorText: {
      label: 'Failed without an error line',
      reason:
        'Processing failed but no error was written to the log. Re-running is the only way to find out more.',
    },
    unknown: {
      reason:
        'This error is not one we recognise. The recommended action re-runs the work from the start.',
    },
  },
  verbs: {
    reparse: {
      label: 'Re-parse',
      hint: "Deletes all of the document's chunks, then parses from scratch.",
    },
    resume: {
      label: 'Resume from last step',
      hint: 'Re-queues only the failed tasks of a document; completed steps are kept.',
    },
    reupload: {
      label: 'Re-upload',
      hint: 'Replace the stored file with a readable copy in Documents, then parse it.',
    },
    reconnect: {
      label: 'Reconnect account',
      hint: 'Re-authorizes the source account in Connectors; syncing becomes available again.',
    },
    retryFailed: {
      label: 'Retry failed',
      hint: 'Retries the items that failed or were interrupted in the last run, resuming where each stopped.',
    },
    cancelImport: {
      label: 'Cancel import',
      hint: 'Stops the running import so a new run can start.',
    },
    authorizeModel: {
      label: 'Authorize model',
      hint: 'Enable the model (or pick another default) in Model providers.',
    },
    contactAdmin: {
      label: 'Contact administrator',
      hint: 'Needs a fix on the server side; there is nothing to press here.',
    },
    openConfiguration: {
      label: 'Open Configuration',
      hint: 'Change or regenerate the setting in this knowledge base’s Configuration.',
    },
  },
  actions: {
    cancelConfirm: 'Cancel the running import for {{account}}?',
    started: 'Started',
    failed: 'The action failed: {{message}}',
    batchesFailed_one: '{{count}} batch was not accepted',
    batchesFailed_other: '{{count}} batches were not accepted',
    contactAdmin: 'Ask an administrator to fix this',
  },
  rail: {
    causes: 'Errors by cause',
    causesHint: 'affected items · bar length = count · opens card #',
    glossary: 'Recovery verbs',
    glossaryHint: 'What each action actually does.',
  },
};
